import manifest from './routeLocaleManifest.json';

export interface RouteLocaleDescriptor {
  id: string;
  namespaces: readonly string[];
  prefetch: readonly string[];
}

const descriptor = (id: keyof typeof manifest): RouteLocaleDescriptor => ({
  id,
  namespaces: manifest[id].namespaces,
  prefetch: manifest[id].prefetch,
});

const descriptors = {
  characters: descriptor('characters'),
  wizard: descriptor('wizard'),
  knowledge: descriptor('knowledge'),
  encounter: descriptor('encounter'),
  initiative: descriptor('initiative'),
  treasure: descriptor('treasure'),
  gmHelp: descriptor('gm-help'),
  companions: descriptor('companions'),
  admin: descriptor('admin'),
  localization: descriptor('localization'),
  coreOnly: descriptor('core-only'),
};

const byId = new Map<string, RouteLocaleDescriptor>(
  Object.values(descriptors).map((descriptor) => [descriptor.id, descriptor]),
);

export const ROUTE_UI_NAMESPACES = [...new Set(
  Object.values(descriptors).flatMap((descriptor) => descriptor.namespaces),
)].sort();

export function getRouteLocaleDescriptor(pathname: string): RouteLocaleDescriptor {
  if (pathname === '/' || pathname === '/characters') return descriptors.characters;
  if (pathname === '/create' || /^\/[^/]+\/edit\/?$/.test(pathname)) return descriptors.wizard;
  if (pathname.startsWith('/knowledge')) return descriptors.knowledge;
  if (pathname.startsWith('/encounter-builder')) return descriptors.encounter;
  if (pathname.startsWith('/initiative-tracker')) return descriptors.initiative;
  if (pathname.startsWith('/treasure-planner')) return descriptors.treasure;
  if (pathname.startsWith('/gm-help')) return descriptors.gmHelp;
  if (pathname.startsWith('/companions') || pathname.includes('/companions/setup')) {
    return descriptors.companions;
  }
  if (pathname.startsWith('/admin')) return descriptors.admin;
  if (pathname.startsWith('/localization')) return descriptors.localization;
  if (
    pathname.startsWith('/login')
    || pathname.startsWith('/register')
    || pathname.startsWith('/forgot-password')
    || pathname.startsWith('/force-password-change')
    || pathname.startsWith('/force-2fa-setup')
    || pathname.startsWith('/legal')
    || pathname.startsWith('/user')
  ) {
    return descriptors.coreOnly;
  }
  if (/^\/[^/]+\/?$/.test(pathname)) return descriptors.characters;
  return descriptors.coreOnly;
}

export function getPrefetchRouteDescriptors(
  descriptor: RouteLocaleDescriptor,
): RouteLocaleDescriptor[] {
  return descriptor.prefetch
    .map((id) => byId.get(id))
    .filter((candidate): candidate is RouteLocaleDescriptor => Boolean(candidate));
}
